import { defineStore } from 'pinia';
import {actions} from './actions.js';

export const useBrandChannelStore = defineStore('brandChannel', {
  state: () => ({  tape: {} }),
  getters: {},
  actions
});
